import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { Component, forwardRef, Inject, Input } from '@angular/core';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { NgForm }                               from '@angular/forms';
import { TranslateService }                     from '@ngx-translate/core';

import { BigDecimalService }    from '../core/services/big-decimal.service';
import { DvlaLookupPriceModel } from './typings/dvla-lookup.price';
import { DvlaLookupQuoteModel } from './typings/dvla-lookup.quote';
import { DvlaLookupService }    from './dvla-lookup.service';
import { GlobalCurrencyPipe }   from '../shared/pipes/global-currency.pipe';
import { MessagesService }      from '../messages/messages.service';

@Component({
  selector   : 'wor-purchase-dvla-lookups',
  template: require('./dvla-lookup.purchase.component.html')
})
export class PurchaseDvlaLookupsComponent {
  @BlockUI('purchaseDvlaLookupsBlock') block : NgBlockUI;

  @Input() price : DvlaLookupPriceModel;

  public isPurchasing = false;

  public quote : DvlaLookupQuoteModel = {};

  constructor (
    public  activeModal        : NgbActiveModal,
    private bigDecimalService : BigDecimalService,
    @Inject(forwardRef(() => DvlaLookupService))
    private dvlaLookupService : DvlaLookupService,
    private globalCurrencyPipe: GlobalCurrencyPipe,
    private messagesService   : MessagesService,
    private translateService  : TranslateService
  ) {}

  confirm () : void {
    this.block.start();

    this.isPurchasing = true;

    this.dvlaLookupService.confirmPurchase(this.quote)
    .then(() => this.activeModal.close())
    .catch(error => this.messagesService.error(error))
    .finally(() => {
      this.block.stop();

      this.isPurchasing = false;
    });
  }

  getLabel ( form : NgForm ) : string {
    return this.quote.quantity < 100 || form?.controls?.quantity?.invalid && form?.controls?.quantity?.dirty
      ? this.translateService.instant('GENERAL_SPACE.ERROR_MESSAGE.INVALID_QUANTITY')
      : this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.NUMBER_OF_REQUESTS');
  }

  updatePrice ( quantity : string ) : void {
    const price = this.bigDecimalService.get(this.price.price);

    quantity = this.bigDecimalService.get(quantity);

    this.quote.price = this.globalCurrencyPipe.transform(price.multiply(quantity).toString());
  }
}
